
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/genomes/bacteriology",
      function () {
        return require("private-next-pages/genomes/bacteriology.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/genomes/bacteriology"])
      });
    }
  